import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["destroyTileButton"]

  // this fires before the action has completed so the only way to know if there will be one more or one fewer tile afterwards is two separate methods that are called explicitly by the according buttons

  showDestroyButtons() {
    this.destroyTileButtonTargets.forEach((target) =>
      target.classList.remove("hidden"),
    )
  }

  hideSoleDestroyButton() {
    const targets = this.destroyTileButtonTargets

    if (targets.length <= 2) {
      targets.forEach((target) => target.classList.add("hidden"))
    }
  }
}
